export default __webpack_public_path__ + "static/media/M1A_6.57290ca8.png";